/** Concatenate the value to the unit and pluralize the unit if needed */
export function createStringWithTimeUnit(value: number, unit: 'hour' | 'day') {
  if (value === 1) {
    return `${value} ${unit}`
  }

  // Pluralize if more than one value
  return `${value} ${unit}s`
}
